export default __webpack_public_path__ + "static/media/project4.0d9db847.png";